import CloseIcon from "@styles/all-images/icons/closeblack.svg";
import { useDispatch } from "react-redux";
import { AppThunkDispatch } from "@/store";
import actionsHandler from "@/store/actions/actionHandler";
import { useState } from "react";
import { toast } from "react-toastify";

interface TierRejectionReasonProps {
  onClose: () => void;
  onSubmit: () => void;
  taskId: number;
}

const ToDoDeleteTask = ({
  onClose,
  onSubmit,
  taskId,
}: TierRejectionReasonProps) => {
  const dispatch = useDispatch<AppThunkDispatch>();
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    try {
      setIsDeleting(true);
      const { authenticatedCall } = actionsHandler("todoById");

      const response = await dispatch(
        authenticatedCall({
          method: "delete",
          customParams: [taskId + "/"],
        }),
      );

      if (response.ok) {
        toast.success("Task deleted successfully");
        onSubmit();
        onClose();
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Unable to delete task. Please try again later");
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="tw-fixed tw-inset-0 tw-bg-black/25 tw-flex tw-items-center tw-justify-center tw-z-50">
      <div className="tw-bg-white tw-rounded-lg tw-w-[400px]">
        <div className="tw-flex tw-justify-between tw-items-center tw-px-4 tw-py-4 tw-border-b">
          <div></div>
          <h2 className="tw-text-base tw-font-semibold">Delete Task?</h2>
          <button onClick={onClose}>
            <img src={CloseIcon} alt="Close" className="tw-w-auto tw-h-auto" />
          </button>
        </div>
        <div className="tw-p-4 tw-text-center tw-flex tw-flex-col tw-gap-2 tw-py-5 tw-px-6">
          <h6 className="tw-text-[#232323] tw-text-base tw-font-semibold">
            Are you sure you want to delete?
          </h6>
          <p className="tw-text-[#232323] tw-text-sm tw-font-normal">
            Deleting a task will permanently remove it.
          </p>
        </div>
        <div className="tw-flex tw-space-x-4 tw-py-5 tw-px-12">
          <button
            onClick={onClose}
            className="tw-flex-1 tw-px-4 tw-py-2 tw-border font-default-primary-color tw-border-[#146C94] tw-rounded-lg tw-w-[50%] tw-text-center"
          >
            No
          </button>
          <button
            onClick={handleDelete}
            disabled={isDeleting}
            className="tw-bg-blue-600 hover:tw-bg-blue-700 tw-flex tw-items-center tw-gap-2 tw-w-[50%] tw-justify-center tw-text-white tw-rounded-md tw-px-4 tw-py-2 primary-custom-button"
          >
            {isDeleting ? "Deleting..." : "Yes"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ToDoDeleteTask;
